import { FC, useState } from "react"
import { useTranslation } from "react-i18next"

import { Grid, GridItem } from "components/Grid"
import Select, { ISelectOption } from "components/Select/Select"
import InputSearch from "components/InputSearch/InputSearch"
import { GroupedControl } from "config/constants"
import { TextBuildingBlockSearchScope } from "models/TextBuildingBlock"

interface ITextBuildingBlocksFilterProps {
    onChange(scope: TextBuildingBlockSearchScope, search: string): void
}

const TextBuildingBlocksFilter: FC<ITextBuildingBlocksFilterProps> = ({
    onChange,
}) => {
    const { t } = useTranslation()
    const [search, setSearch] = useState("")
    const [scope, setScope] = useState(TextBuildingBlockSearchScope.text)

    const filterScopeSelectOptions: ISelectOption[] = [
        { label: t('textBuildingBlocks.text'), value: TextBuildingBlockSearchScope.text },
        { label: t('textBuildingBlocks.id'), value: TextBuildingBlockSearchScope.id },
    ]

    function handleFilterScopeChange(newFilterScope?: TextBuildingBlockSearchScope) {
        if (!newFilterScope) {
            return
        }
        setScope(newFilterScope)
        if (search) {
            onChange(newFilterScope, "")
        }
        setSearch("")
    }

    function handleSearchReset() {
        setSearch("")
        onChange(scope, "")
    }

    return (
        <Grid columns="minmax(0, 1fr) minmax(0, 2fr)">
            <GridItem>
                <Select
                    options={filterScopeSelectOptions}
                    value={scope}
                    onChange={item => handleFilterScopeChange(item?.value)}
                    grouped={GroupedControl.left}
                    testIdPrefix="filter-scope-select"
                />
            </GridItem>
            <GridItem>
                <InputSearch
                    placeholder={t('common.searchAndFilter')}
                    grouped={GroupedControl.right}
                    value={search}
                    onChange={setSearch}
                    onPressEnter={currentSearch => onChange(scope, currentSearch)}
                    debounceMs={0}
                    onReset={handleSearchReset}
                />
            </GridItem>
        </Grid>
    )
}

export default TextBuildingBlocksFilter
